import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { firebase } from '../firebase';

const withAuthentication = (Component) => {
  class WithAuthentication extends React.Component {
	  constructor(props) {
	    super(props);

	    this.state = {
	      	authUser: null,
			authToken: null
	    };
	  }

      getChildContext() {
        return {
          	authUser: this.state.authUser,
			authToken: this.state.authToken
        };
      }

	  componentWillMount() {
	    firebase.auth.onAuthStateChanged(authUser => {
			if (authUser) {
				authUser.getIdToken().then(authToken => {
					this.setState(() => ({ authUser: authUser, authToken: authToken }));
				});
			}
	    });
	  }

	  render() {
		  return (
			  <Component {...this.props} authUser={this.state.authUser} authToken={this.state.authToken}/>
		  );
	  }
  }

  WithAuthentication.childContextTypes = {
	  authUser: PropTypes.object,
	  authToken: PropTypes.string
  };

  return withRouter(WithAuthentication);
}

export default withAuthentication;



// WEBPACK FOOTER //
// ./src/components/withAuthentication.js